import Link from 'next/link'
import React from 'react'

const AssortmentInfo = ({ item }) => {
    return (
        <div className="megaschool__info">
            <div className="megaschool__info-top">
                <p className="megaschool__card-tag categories-slider__text">{item.tag}</p>
                <h3 className="megaschool__card-title">{item.title}</h3>
                <p className="megaschool__info-text">{item.text}</p>
            </div>
            <div className="megaschool__info-buttons">
                <Link
                    target='_blank'
                    style={{ display: 'contents' }}
                    href={item.btn.link}>
                    <button className="megaschool__info-btn megaschool__info-btn_orange">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9.2" stroke="#FEC2BA" strokeWidth="1.6" />
                            <path d="M13.2 10C13.2 12.6857 12.7631 15.0803 12.0856 16.774C11.746 17.623 11.3616 18.2564 10.9757 18.6645C10.5914 19.0708 10.2614 19.2 10 19.2C9.73857 19.2 9.40857 19.0708 9.02426 18.6645C8.63836 18.2564 8.25397 17.623 7.91435 16.774C7.2369 15.0803 6.8 12.6857 6.8 10C6.8 7.3143 7.2369 4.91969 7.91435 3.22604C8.25397 2.377 8.63836 1.7436 9.02426 1.33554C9.40857 0.929164 9.73857 0.8 10 0.8C10.2614 0.8 10.5914 0.929164 10.9757 1.33554C11.3616 1.7436 11.746 2.377 12.0856 3.22604C12.7631 4.91969 13.2 7.3143 13.2 10Z" stroke="#FEC2BA" strokeWidth="1.6" />
                            <line x1="1" y1="10.2" x2="19" y2="10.2" stroke="#FEC2BA" strokeWidth="1.6" />
                        </svg>
                        <p>{item.btn.content}</p>
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default AssortmentInfo
